export const MIN_PRIORITY_0 = 0;
export const MAX_PRIORITY_100 = 100;



// WEBPACK FOOTER //
// ./constants/validation.js